const SinoaSelection = () => import('@/pages/chatbot/SinoaSelection.vue');

const routes = [
  {
    path: '/chatbot/sinoa-selection/',
    meta: {
      title: 'Sinoa Selection',
    },
    component: SinoaSelection,
  },
];

export default routes;
